// Aktualizuje počet zobrazených produktů v elementu s id "products-count"
function updateProductsCount() {
  const grid = document.querySelector('.product-grid');
  if (!grid) return;
  const items = grid.querySelectorAll('.product-grid__item:not(.product-grid__item--banner)');
  const count = items.length;
  const countWrapper = document.querySelector('[data-testid="products-count"] span');
  if (countWrapper) {
    countWrapper.textContent = Theme.translations?.item_count?.replace('{{ count }}', count) || `Zobrazeno ${count} produktů`;
  }
}

window.addEventListener('DOMContentLoaded', updateProductsCount);
document.addEventListener('products:updated', updateProductsCount);